import { createGlobalStyle } from 'styled-components';
import { isTMSTheme } from 'services/ui';
import { lightColorsTMS, darkColorsTMS, lightColorsLearnIT, darkColorsLearnIT } from './darkColors';

const light = isTMSTheme() ? lightColorsTMS : lightColorsLearnIT;
const dark = isTMSTheme() ? darkColorsTMS : darkColorsLearnIT;

export const GlobalThemeStyles = createGlobalStyle`
  :root,
  [data-theme='light'] {
    --color-main: ${light.main};
    --color-main-light: ${light.main_light};
    --color-main-dark: ${light.main_dark};
    --color-system-gray: ${light.system_gray};
    --color-white: ${light.white};
    --color-bg-gray: ${light.bg_gray};
    --color-additional-gray: ${light.additional_gray};
    --color-gray: ${light.gray};
    --color-gray-dark: ${light.gray_dark};
    --color-black: ${light.black};
    --color-btn-text: ${light.btn_text};
    --color-btn-hover-text: ${light.btn_hover_text};
    --color-signal-red: ${light.signal_red};
    --color-signal-green: ${light.signal_green};
    --color-marker-green: ${light.marker_green};
  }

  [data-theme='dark'] {
    --color-main: ${dark.main};
    --color-main-light: ${dark.main_light};
    --color-main-dark: ${dark.main_dark};
    --color-system-gray: ${dark.system_gray};
    --color-white: ${dark.white};
    --color-bg-gray: ${dark.bg_gray};
    --color-additional-gray: ${dark.additional_gray};
    --color-gray: ${dark.gray};
    --color-gray-dark: ${dark.gray_dark};
    --color-black: ${dark.black};
    --color-btn-text: ${dark.btn_text};
    --color-btn-hover-text: ${dark.btn_hover_text};
    --color-signal-red: ${dark.signal_red};
    --color-signal-green: ${dark.signal_green};
    --color-marker-green: ${dark.marker_green};
  }
`;
